import { Navigate } from 'react-router-dom';
import { useAuth } from '../infrastructure/auth0/useAuth';
import { useQueryParams } from '../hooks/useQueryParams';

/**
 * これは厳密にはログインページではない
 * 招待メールなどのリンクが `https://{frontend のドメイン}/login?hoge=fuga` の形式になっており、
 * その query string などを見て適切に Auht0 の認証ページに飛ばすなどの処理をするページである
 */

const Login = () => {
  const { loginWithRedirect } = useAuth();
  const queryParams = useQueryParams();

  const queryInvitation = queryParams.get('invitation');
  const queryOrganization = queryParams.get('organization');

  // query に `invitation` と `organization` が指定されている場合、Auth0 の認証フローに飛ばす
  if (queryInvitation && queryOrganization) {
    loginWithRedirect({
      authorizationParams: {
        invitation: queryInvitation,
        organization: queryOrganization,
      },
    });
    return null;
  }

  // 特に何もなければトップページへリダイレクト
  return <Navigate to="/" replace />;
};

export { Login };
